import { ILoanCalculatorState, PREDEFINED_PERIODS_OFFER_LOGIC } from '../../../store/types'

export enum LoanCalculatorSlidersTypes {
   amount = 'amount',
   period = 'period',
}

export interface LoanOfferSummaryPanelProps {
   /** Czy panel ma być domyślnie otwarty po zamontowaniu komponentu */
   defaultOpen?: boolean
   /** Wariant przeliczenia z którego chcemy korzystać. Predefined to predefiniowana oferta, selectedOffer to oferta już wybrana i zatwierdzona przez użytkownika */
   loanVariant?: 'predefined' | 'selectedOffer'
   /** Czy panel jest w trybie tylko do odczytu (brak przycisku do rozwijania) */
   readOnly?: boolean
}

export interface UseLoanOfferSummaryPanelLogicProps {
   /** Czy panel ma być domyślnie otwarty po zamontowaniu komponentu */
   defaultOpen?: boolean
   /** Wariant przeliczenia z którego chcemy korzystać. Predefined to predefiniowana oferta, selectedOffer to oferta już wybrana i zatwierdzona przez użytkownika */
   loanVariant?: 'predefined' | 'selectedOffer'
}

export interface LoanShortSummaryData {
   requestedAmount: number
   instalments?: number
   instalmentAmount?: number
}


export interface UseLoanOfferSummaryPanelLogicReturnProps {
   loanShortSummaryData: LoanShortSummaryData
   loanCalculatorStateParams: ILoanCalculatorState
   isLoanCalculatorOpen: boolean
   isLoading: boolean
   setLoanCalculatorOpen: (isOpen: boolean) => void
   onLoanValueSliderUpdate: (newSliderValue: number, type: LoanCalculatorSlidersTypes) => Promise<void>
   handleOnPredefinedPeriodButtonClick: (newSelectedPeriod: PREDEFINED_PERIODS_OFFER_LOGIC) => Promise<void>
   onValueChanged: () => void
}